export default __webpack_public_path__ + "static/dashboard2-486ebce5ae64618f37f200f0495258f5.png";